





















import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'

export default Vue.extend({
  data() {
    return {
      rightMenu: [
        {
          title: 'View',
          children: [
            { title: 'New', icon: 'app-indicator' },
            {
              title: 'Save',
              icon: 'check-circle',
            },
            { divider: true },
            { title: 'Duplicate', icon: 'files' },
            { divider: true },
            { title: 'Delete', icon: 'trash' },
          ],
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['isEditor']),
    ...mapState('view', { view: 'items' }),
    ...mapState(['user']),
  },
  methods: {
    handleSave() {
      this.$emit('save')
    },
    handleSetAsDefault() {
      this.$emit('default')
    },
    handleProperties() {
      this.$emit('properties')
    },
    handleNew() {
      this.$emit('new')
    },
    handleDuplicate() {
      this.$emit('duplicate')
    },
    handleDelete() {
      this.$emit('delete')
    },
    async handleLogout() {
      await this.$store.dispatch('user/logout')
      this.$router.push({ path: '/login' })
    },
  },
})
